import { forwardRef } from 'react';
import CancelButton from './CancelButton';
import SubmitButton from './SubmitButton';

interface Props {
  onSubmit: () => void;
  onCancel: () => void;
  submitButtonRef?: React.Ref<HTMLButtonElement>;
  cancelButtonRef?: React.Ref<HTMLButtonElement>;
  onSubmitKeyDown?: (e: React.KeyboardEvent<HTMLButtonElement>) => void;
  onCancelKeyDown?: (e: React.KeyboardEvent<HTMLButtonElement>) => void;
}

const SubmitAndCancelButton = forwardRef<HTMLDivElement, Props>(
  ({
    onSubmit,
    onCancel,
    submitButtonRef,
    cancelButtonRef,
    onSubmitKeyDown,
    onCancelKeyDown,
  }: Props) => {
    return (
      <div className="d-flex gap-2">
        <SubmitButton
          onClick={onSubmit}
          ref={submitButtonRef}
          onKeyDown={onSubmitKeyDown}
        />
        <CancelButton
          onClick={onCancel}
          ref={cancelButtonRef}
          onKeyDown={onCancelKeyDown}
        />
      </div>
    );
  }
);

SubmitAndCancelButton.displayName = 'SubmitAndCancelButton';
export default SubmitAndCancelButton;
